<div class="toast-container position-fixed bottom-0 end-0 p-3">
  @for(toast of toastService.toasts; track $index) {
  <ngb-toast (hidden)="toastService.remove(toast)" [class]="toast.classname" [autohide]="true" [delay]="toast.delay||5000">
    {{ toast.body }}
  </ngb-toast>
  }
</div>
